import { erSann, garanterListe } from '../';

export function getFartsgrenser(vegstrekninger) {
	const fartsgrenser = garanterListe(vegstrekninger)
		.flatMap((vegstrekning) =>
			garanterListe(vegstrekning && vegstrekning.fartsgrenser)
		)
		.map((fartsgrense) => fartsgrense.fartsgrense)
		.sort((a, b) => a - b);
	return [...new Set(fartsgrenser)];
}

export function getHoyesteTrafikkmengde(vegstrekninger) {
	return garanterListe(vegstrekninger)
		.flatMap((vegstrekning) =>
			garanterListe(vegstrekning && vegstrekning.trafikkmengder)
		)
		.sort((a, b) => b.arsdognstrafikk - a.arsdognstrafikk)[0];
}

export function getNyesteFartsgrense(vegposisjon) {
	return garanterListe(vegposisjon && vegposisjon.fartsgrenser).sort(
		(a, b) => a.gyldigFraDato - b.gyldigFraDato
	)[0];
}

export function vegsystemTilKortform(vegsystem) {
	return (
		(vegsystem.vegkategori || '') +
		(vegsystem.fase || '') +
		(vegsystem.nummer || '')
	);
}

export function strekningTilKortform(strekning = {}) {
	return (
		(strekning.strekning ? 'S' + strekning.strekning : '') +
		(strekning.delstrekning ? 'D' + strekning.delstrekning : '') +
		(strekning.meter !== undefined && strekning.meter !== null
			? ' M' + strekning.meter
			: '')
	);
}

export function getNyesteTrafikkmengde(vegposisjon) {
	return garanterListe(vegposisjon && vegposisjon.trafikkmengder).sort(
		(a, b) => a.gjelderAr - b.gjelderAr
	)[0];
}

export function sideanleggTilKortform(sideanlegg = {}) {
	return (
		(sideanlegg.sideanleggsdel ? 'SD' + sideanlegg.sideanleggsdel : '') +
		(sideanlegg.meter !== undefined && sideanlegg.meter !== null
			? ' M' + sideanlegg.meter
			: '')
	);
}

export function kryssystemTilKortform(kryssystem = {}) {
	return (
		(kryssystem.kryssystem ? 'K' + kryssystem.kryssystem : '') +
		(kryssystem.kryssdel ? 'D' + kryssystem.kryssdel : '') +
		(kryssystem.meter !== undefined && kryssystem.meter !== null
			? ' M' + kryssystem.meter
			: '')
	);
}

export function vegsystemreferanseTilKortform(vegsystemreferanse = {}) {
	return [
		vegsystemTilKortform(vegsystemreferanse.vegsystem),
		strekningTilKortform(vegsystemreferanse.strekning),
		kryssystemTilKortform(vegsystemreferanse.kryssystem),
		sideanleggTilKortform(vegsystemreferanse.sideanlegg),
	]
		.map((del) => String(del || ''))
		.filter(erSann)
		.join(' ');
}

export function vegsystemreferanseTilTrafikantgruppe(vegsystemreferanse = {}) {
	return (
		vegsystemreferanse.kryssystem?.trafikantgruppe ||
		vegsystemreferanse.sideanlegg?.trafikantgruppe ||
		vegsystemreferanse.strekning?.trafikantgruppe ||
		''
	);
}

export function vegsystemreferanseTilKortformMedTrafikantgruppe(
	vegsystemreferanse
) {
	const trafikantgruppe = vegsystemreferanseTilTrafikantgruppe(
		vegsystemreferanse
	);
	return (
		vegsystemreferanseTilKortform(vegsystemreferanse) +
		(trafikantgruppe ? ' (' + trafikantgruppe + ')' : '')
	);
}
